/**
 * @voltxampere/ui — LM339 quad comparator variant (Sprint 39-4)
 *
 * Quad-channel sibling of LM393 in DIP-14. Same per-channel specs;
 * the visual representation is the single-channel triangle since the
 * canvas does not draw multi-channel ICs as a unit.
 *
 * Reference: TI SNOSBV4F. Engine zero-diff invariant honored.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const opampLm339 = {
    id: "lm339",
    nameTr: "LM339 (4'lü Karşılaştırıcı, DIP-14)",
    nameEn: "LM339 (Quad Comparator, DIP-14)",
    shortcut: "O",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "LM339",
    schemaType: "opamp",
    defaultParams: {
        openLoopGain: 2e5,
        saturationVoltage: 0.4,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=opamp-lm339.js.map